import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import * as timeline from '../../lib/timeline';
import { withUser } from '../../lib/user';
import Card from '../../components/Card';
import Avatar from '../../components/Avatar';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import Dialog from '../../components/Dialog';
import { T } from '../../components/I18n';

class ScheduledReportCard extends PureComponent {
  state = {
    confirmDelete: false
  };

  render() {
    const { schedule, report, usersById, catalog, location: { search }, onDelete } = this.props;
    const { confirmDelete } = this.state;

    return (
      <Card
        active={confirmDelete}
        overlay={confirmDelete && (
          <SmallDialog
            title="Are you sure?"
            description={schedule.interval
              ? "Are you sure you want to delete this recurring scheduled report?"
              : "Are you sure you want to delete this scheduled report?"}
            buttons={[
              <Button key="delete" onClick={() => onDelete(report, schedule)}>Delete</Button>,
              <Button key="cancel" secondary onClick={() => this.setState({ confirmDelete: false })}>Cancel</Button>
            ]}
          />
        )}>
        <Header active={confirmDelete}>
          <H1>{report.name}</H1>
          <Description>{getParameterSummary(schedule, report, catalog)}</Description>
          {getRepeatFriendlyText(schedule)}
        </Header>
        <Card.Footer
          start={(
            <Avatar.Group>
              {schedule.userIds
                .map(userId => usersById[userId])
                .sort((a, b) => a.userName.localeCompare(b.userName))
                .map(user => <Avatar key={user.id} user={user} />)}
            </Avatar.Group>
          )}
          end={(
            <Button.Group>
              <Button to={`/reports/schedules/${schedule.id + search}`}>Edit</Button>
              <Button onClick={() => this.setState({ confirmDelete: true })}><Icon name="trash-2" /></Button>
            </Button.Group>
          )}
        />
      </Card>
    );
  }
}

function getRepeatFriendlyText(job) {
  const date = new Date(job.scheduleTime);

  if (job.scheduleTime === null) {
    return "Not Scheduled";
  }

  switch (job.interval) {
    case "DAY":
      return <Description>Every day at <T variable="time">{date.toLocaleTimeString()}</T></Description>
    case "WEEK":
      return <Description>Every <T variable="time">{timeline.DAYS[date.getDay()]}</T> at <T variable="time">{date.toLocaleTimeString()}</T></Description>;
    case "MONTH":
      const dayNum = date.getDate();
      return <Description><T variable="time">{dayNum}{timeline.getSuffix(dayNum)}</T> of every month at <T variable="time">{date.toLocaleTimeString()}</T></Description>;
    case "NEVER":
    default:
      return <Description>On {timeline.getFriendlyDateName(date)} at <T variable="time">{date.toLocaleTimeString()}</T></Description>;
  }
}

function getParameterSummary(job, report, catalog) {
  const catalogMap = catalog.reduce((map, item) => {
    map[item.id] = item;
    return map;
  }, {});
  let summary = '';

  if (Object.keys(job.parameters).length > 0) {
    summary += "Data for ";

    if (job.parameters.timeInterval) {
      summary += "the last ";
      summary += job.parameters.timeInterval > 1 ? (job.parameters.timeInterval + " days") : " day";
    }

    if (job.parameters.catalog_item) {
      summary += job.parameters.timeInterval ? ", " : "";
      summary += "catalog: ";
      summary += catalogMap[job.parameters.catalog_item].name;
    }

    const remainParams = report.parameters
      .filter(parameter => parameter.name !== "end_date" && parameter.name !== "start_date" && parameter.name !== "catalog_item");

    remainParams.forEach((parameter, index) => {
      summary += " " + parameter.label + " " + (parameter.dataType === 4 || parameter.dataType === 7) ? new Date(parseInt(job.parameters[parameter.name], 10)) : job.parameters[parameter.name];
      summary += (index < remainParams.length - 1) ? ", " : "";
    });

    summary += summary ? " will be emailed" : "";
  }
  else {
    summary = 'All data will be emailed';
  }

  return summary;
}

const Header = styled.div`
  padding: ${props => props.active ? '1.75rem' : '1.875rem'};
`;

const H1 = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Description = styled.p`
  margin: 0;
  margin-top: 0.625rem;
  font-weight: 400;
  line-height: 1.5;
`;

const SmallDialog = styled(Dialog)`
  width: 20rem;
`;

export default withRouter(withUser(ScheduledReportCard));